import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  resetOnClickFilter,
  applyFilterInMyClientsTable,
} from "../../redux/actions";
import styled from "styled-components";

const BodyWrapper = styled.div`
  .heading {
    font-weight: 700;
    font-size: 12px;
    color: #004576;
    margin-bottom: 10px;
  }

  .checkBoxName {
    font-weight: 400;
    font-size: 16px;
    color: #3a3a3d;
    margin-left: 10px;
  }
`;

const AdvisorFilter = () => {
  const dispatch = useDispatch();
  const {
    filterSaveClickColumnName,
    filterClearClickColumnName,
    filterDataOnClientTable,
  } = useSelector((state) => state.user);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsByText, setSelectedOptionsByText] = useState([]);
  const statusForFilter = [
    {
      id: "1",
      name: "Registered",
    },
    {
      id: "2",
      name: "In Progress",
    },
    {
      id: "3",
      name: "Ready To Launch",
    },
    {
      id: "4",
      name: "Funded",
    },
    {
      id: "5",
      name: "Active",
    },
    {
      id: "6",
      name: "Account Opened",
    },
    {
      id: "8",
      name: "Abandoned",
    },
  ];

  useEffect(() => {
    if (filterClearClickColumnName === "Status") {
      setSelectedOptions([]);
      setSelectedOptionsByText([]);
      dispatch(resetOnClickFilter());
    }
  }, [filterClearClickColumnName]);

  useEffect(() => {
    if (filterSaveClickColumnName === "Status") {
      let tempFilter = [...filterDataOnClientTable];
      if (selectedOptions.length <= 0) {
        tempFilter = tempFilter.filter((data) => data.columnName !== "Status");
        dispatch(applyFilterInMyClientsTable(tempFilter));
      } else {
        let flag = 0;
        tempFilter.forEach((data) => {
          if (data.columnName === "Status") {
            data.values = selectedOptions;
            data.valuesText = selectedOptionsByText;
            flag = 1;
          }
        });
        if (flag === 0) {
          tempFilter.push({
            columnName: "Status",
            values: selectedOptions,
            valuesText: selectedOptionsByText,
          });
        }
        dispatch(applyFilterInMyClientsTable(tempFilter));
      }

      dispatch(resetOnClickFilter());
    }
  }, [filterSaveClickColumnName]);

  const handleCheckBoxClick = (event) => {
    let tempArray = [...selectedOptions];
    let tempArrayByText = [...selectedOptionsByText];
    if (tempArray.find((data) => data === event.target.value)) {
      tempArray.splice(
        tempArray.findIndex((a) => a === event.target.value),
        1
      );
      tempArrayByText.splice(
        tempArrayByText.findIndex((a) => a === event.target.name),
        1
      );
    } else {
      tempArrayByText.push(event.target.name);
      tempArray.push(event.target.value);
    }
    setSelectedOptions(tempArray);
    setSelectedOptionsByText(tempArrayByText);
  };

  useEffect(() => {
    let advisorFilterData = filterDataOnClientTable.find(
      (data) => data.columnName === "Status"
    );

    if (
      advisorFilterData !== undefined &&
      advisorFilterData.hasOwnProperty("columnName")
    ) {
      setSelectedOptions(advisorFilterData?.values || []);
      setSelectedOptionsByText(advisorFilterData?.valuesText || []);
    }
  }, [filterDataOnClientTable]);

  return (
    <BodyWrapper>
      <div className="heading">Select</div>
      {statusForFilter &&
        statusForFilter.length > 0 &&
        statusForFilter.map((data) => (
          <div>
            <input
              value={data.id}
              type="checkbox"
              name={data.name}
              checked={selectedOptions.indexOf(data.id) > -1 ? true : false}
              onChange={handleCheckBoxClick}
            />
            <span className="checkBoxName">{data.name}</span>
          </div>
        ))}
    </BodyWrapper>
  );
};

export default AdvisorFilter;
